import AppSettingsModal from "./AppSettingsModal";
import CheckoutEmailPromptModal from "./CheckoutEmailPromptModal";
import GlobalVirtualKeyboard from "./GlobalVirtualKeyboard";

const AppOverlays = () => {
    return (
        <>
            <CheckoutEmailPromptModal />
            <AppSettingsModal />
            <GlobalVirtualKeyboard />
        </>
    );
};

export default AppOverlays;
